import Typography from "@mui/material/Typography";
import { COLOR_WHITE } from "shared/theme/colors";


export const EmojiContent = () => (
  <Typography variant="bodySRegular" textAlign="center" color={COLOR_WHITE}>
    Press{" "}
    <Typography variant="bodySSemiBold" color={COLOR_WHITE}>
      Ctrl + Cmd + Space
    </Typography>{" "}
    (Mac) or <br />{" "}
    <Typography variant="bodySSemiBold" color={COLOR_WHITE}>
      Windows + Period
    </Typography>{" "}
    (Win) to open the emoji panel.
  </Typography>
);